import React, { useCallback, useEffect, useRef, useState } from 'react';
import { RefreshCw } from 'lucide-react';

/**
 * Заметить, что на сервере вышла новая версия интерфейса.
 *
 * Вкладки на складе живут сутками: после деплоя оператор продолжает работать на
 * старом коде и видит старое поведение — исправление «не помогает», хотя на
 * сервере оно уже есть (26.08: печать всего снова ушла на весь план, потому что
 * страница была открыта до выкладки). index.html отдаётся без кэша, поэтому
 * достаточно сверить имя бандла в нём с тем, что загружен сейчас.
 */
export default function VersionWatcher() {
  const loadedRef = useRef(null);
  const [stale, setStale] = useState(false);

  const currentBundle = () => {
    const el = document.querySelector('script[src*="/static/js/main."]');
    const m = el && el.src.match(/main\.[a-z0-9]+\.js/);
    return m ? m[0] : null;
  };

  const check = useCallback(async () => {
    if (stale) return;
    try {
      const res = await fetch(`/index.html?_=${Date.now()}`, { cache: 'no-store' });
      if (!res.ok) return;
      const html = await res.text();
      const m = html.match(/main\.[a-z0-9]+\.js/);
      if (!m) return;
      if (!loadedRef.current) loadedRef.current = currentBundle();
      if (loadedRef.current && m[0] !== loadedRef.current) setStale(true);
    } catch { /* оффлайн — молчим, проверим позже */ }
  }, [stale]);

  useEffect(() => {
    loadedRef.current = currentBundle();
    check();
    const t = setInterval(check, 120000);
    // Возврат на вкладку — самый частый момент, когда версия уже успела уехать
    const onFocus = () => check();
    window.addEventListener('focus', onFocus);
    return () => { clearInterval(t); window.removeEventListener('focus', onFocus); };
  }, [check]);

  if (!stale) return null;

  return (
    <div style={{
      position: 'fixed', left: '50%', transform: 'translateX(-50%)', bottom: 18, zIndex: 4000,
      display: 'flex', alignItems: 'center', gap: 12,
      padding: '11px 16px', borderRadius: 12,
      background: 'var(--bg-card)', border: '1px solid var(--border)',
      borderLeft: '3px solid var(--primary, #7c3aed)',
      boxShadow: '0 12px 32px rgba(15,23,42,0.22)', fontSize: 13,
    }}>
      <RefreshCw size={16} style={{ color: 'var(--primary, #7c3aed)' }} />
      <span>Вышло обновление системы. Эта вкладка работает на старой версии.</span>
      <button
        onClick={() => window.location.reload(true)}
        style={{
          padding: '6px 14px', borderRadius: 8, border: 'none', cursor: 'pointer',
          background: 'var(--primary, #7c3aed)', color: '#fff', fontWeight: 600, fontSize: 13,
        }}
      >
        Обновить
      </button>
    </div>
  );
}
